export const ShuttleBookingCalculator = (bookingData, user) => {
  var normalPrice = 0;  // store original price
  var discounted = 0;   // may change to 0 for promo

  // -------------------------------
  // 1. Compute normal price FIRST
  // -------------------------------
  try {
    if (
      bookingData &&
      bookingData.serviceDetails &&
      bookingData.bookingInfo &&
      bookingData.bookingInfo.distanceDuration
    ) {
      var serviceDetails = bookingData.serviceDetails;
      var basePay = parseFloat(serviceDetails.price) || 30;
      var pricePerMile = 3;

      var distanceText = bookingData.bookingInfo.distanceDuration.distance;
      var distanceInMiles = 0;

      if (distanceText.indexOf("mi") !== -1) {
        distanceInMiles = parseFloat(distanceText);
      } else if (distanceText.indexOf("ft") !== -1) {
        var feet = parseFloat(distanceText);
        distanceInMiles = feet / 5280;
      }

      normalPrice = basePay + pricePerMile * distanceInMiles;
      discounted = normalPrice;
    }
  } catch (err) {
    console.log("Normal price calc error:", err);
  }

  // -------------------------------
  // 2. Check if booking is JAN 2026
  // -------------------------------
  var isJanuaryPromo = false;
  try {
    if (
      bookingData &&
      bookingData.bookingInfo &&
      bookingData.bookingInfo.dateRange &&
      bookingData.bookingInfo.dateRange[0]
    ) {
      var d = new Date(bookingData.bookingInfo.dateRange[0]);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;

      if (year === 2026 && month === 1) {
        isJanuaryPromo = true;
      }
    }
  } catch (err) {
    console.log("Promo date check error:", err);
  }

  // -------------------------------
  // 3. Check Plus membership
  // -------------------------------
  var hasPlus = false;
  try {
    var membership = null;

    if (user && user.clubMembership) {
      membership = user.clubMembership;
    }

    if (!membership && user && user.ClubMemberships && user.ClubMemberships.length > 0) {
      membership = user.ClubMemberships[0];
    }

    if (membership) {
      var plan = membership.planType;
      var active = membership.billingStatus === "active";
      var notCancelled = !membership.cancelledAt;

      if (plan === "Plus" && active && notCancelled) {
        hasPlus = true;
      }
    }
  } catch (err) {
    console.log("Membership check:", err);
  }

  // -------------------------------
  // 4. Apply promo (free shuttle)
  // -------------------------------
  if (isJanuaryPromo && hasPlus) {
    return {
      originalPrice: normalPrice,
      discountedPrice: 0,
      promoApplied: "January 2026 Plus Member Shuttle Promo"
    };
  }

  // -------------------------------
  // 5. No Promo → normal pricing
  // -------------------------------
  return {
    originalPrice: normalPrice,
    discountedPrice: normalPrice
  };
};

export default ShuttleBookingCalculator;
